import React, { Component } from 'react';
import NavLink from './NavLink';
import './Inner.css';

class Inner extends Component {
    render() {
        const { title, children, classname } = this.props;
        return(
            <div>
                <section className="top">   
                    <div className="wrapper content_header clearfix">
                        <div className="work_nav">
                                    
                            <ul className="btn clearfix">
                                <li><NavLink to="/" className="grid" data-title="Portfolio"></NavLink></li>
                            </ul>                           
                            
                        </div>
                        <h1 className="title">{ title }</h1>
                    </div>      
                </section>

                <section className="wrapper">
                    <div className={`content ${classname}`}>
                        { children }
                    </div>
                </section>
            </div>
        )
    }
}

export default Inner;


// WEBPACK FOOTER //
// ./src/components/Inner.js